import { ImoClassStackingRuleDto } from '@yard/app/api/dg-config-api'
import { DGStackingRuleFormProfile } from './dg-stacking-rules-table-form.profile'

export const mapDtoToFormProfile = (dto: ImoClassStackingRuleDto): DGStackingRuleFormProfile => ({
  id: dto.id,
  maxTiers: dto.maxTiers,
  isStackingOnTopAllowed: dto.isStackingOnTopAllowed,
})
